import { useEditor } from "@tiptap/react";
import { useState, useEffect } from "react"
import Sheet from 'react-modal-sheet';
import Tiptap from "../../shared/components/editor/Tiptap";
import StarterKit from "@tiptap/starter-kit"
import { TextStyleKit } from '@tiptap/extension-text-style'
import ZipmapRepository from "../../repository/ZipmapRepository";
import EditButton from "../../shared/components/dashboard/EditButton";
import LocationPickerModal from "../locationpicker/LocationPickerModal";
import Link from "@tiptap/extension-link";
import { LazyLoadImage } from "react-lazy-load-image-component";
import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'
import { downsizeImage } from "../../shared/utils/ImageResizeUtils";

const extensions = [
    TextStyleKit, 
    StarterKit,
    Link.configure({
        openOnClick: false,  // Don't open links when clicked in editor
        HTMLAttributes: {
          class: 'text-blue-500 underline',  // Optional styling
        },
      })
]

export default function DashboardAddMapModal(
    { 
        isAddMapModalOpen,
        onAddMapModalDismiss,
        onMapAdded
    }
) {

    const [toastMessage, setToastMessage] = useState(null)
    const [mapName, setMapName] = useState("")
    const [mapSlug, setMapSlug] = useState("")
    const [coverPhoto, setCoverPhoto] = useState(null)
    const [logoImage, setLogoImage] = useState(null)
    const [mapDefaultView, setMapDefaultView] = useState("MAP")
    const [mapDefaultMarker, setMapDefaultMarker] = useState("📍")
    const [fullScreenLoadingText, setFullScreenLoadingText] = useState(null)

    const editor = useEditor({
        extensions: extensions,
        content: "",
        editorProps: {
            attributes: {
                class: 'w-full min-h-[300px]',
            },
        },
    })

    useEffect(() => {
        if (toastMessage) {
            setTimeout(() => {
                setToastMessage(null)
            }, 3000)
        }
    }, [toastMessage])

    function onMapNameInputChange(event) {
        setMapName(event.target.value)
    }

    function onMapSlugInputChange(event) {
        setMapSlug(event.target.value)
    }

    async function onAddMapFileInputChange(event, type) {
        console.log(`fileInputChange ${type} ${event.target.files[0]}`)
        const file = event.target.files[0]
        const resizedBlob = await downsizeImage(file);
        console.log('Original size:', (file.size / 1024).toFixed(2), 'KB');
        console.log('Resized size:', (resizedBlob.size / 1024).toFixed(2), 'KB');

        let resizedFile = new File([resizedBlob], "fileName.jpg", { type: "image/jpeg" })
        const url = URL.createObjectURL(resizedFile)
        if (type === "cover") {
            setCoverPhoto({file: resizedFile, url: url})
        } else if (type === "logo") {
            setLogoImage({file: resizedFile, url: url})
        }
    }

    async function onAddMapSaveClick() {
        if (mapName.trim() === "") {
            setToastMessage({
                message: "⚠️ Please enter a map name",
                type: "info"
            })
            return
        }

        if (mapSlug.trim() === "") {
            setToastMessage({
                message: "⚠️ Please enter a map URL",
                type: "info"
            })
            return
        }

        console.log(`mapName ${mapName}`)
        console.log(`mapSlug ${mapSlug}`)
        console.log(`mapDefaultMarker ${mapDefaultMarker}`)
        console.log(`mapDefaultView ${mapDefaultView}`)
        console.log(`coverPhoto ${JSON.stringify(coverPhoto)}`)
        console.log(`logoImage ${JSON.stringify(logoImage)}`)
        console.log(`editor ${editor.getHTML()}`)

        setFullScreenLoadingText("Creating new map ...")
        const zipmapRepository = new ZipmapRepository()
        const addedMap = await zipmapRepository.addMap(mapName, mapSlug, mapDefaultMarker, mapDefaultView, coverPhoto, logoImage, editor.getHTML())
        setFullScreenLoadingText(null)
        onMapAdded(addedMap.map)
        onAddMapModalDismiss()
    }

    function onAddMapDefaultMarkerClick() {
        document.getElementById("pick-add-map-emoji-modal").showModal()
    }
    function onEmojiSelected(emoji) {
        setMapDefaultMarker(emoji)
        document.getElementById("pick-add-map-emoji-modal").close()
    }

    return <><Sheet
     isOpen={isAddMapModalOpen} onClose={() => {onAddMapModalDismiss()}} onOpenEnd={() => {}} detent="full-height"
     >
        <Sheet.Container>
        <Sheet.Header />
        <Sheet.Content className="bg-base-300">
        <Sheet.Scroller draggableAt="both">
        <div className="p-4 h-full">
        <div className="pb-8 px-4">
            <div className="font-bold text-xl pb-2 flex items-center font-titan">
                <span className="pr-2">✏️</span>
                Create new map
            </div>
            <div className="font-bold text-base pt-2 pb-2 flex items-center">
                <span>Map name</span>
            </div>
            <div className="flex w-full gap-2">
                <div className="form-control flex-1 relative flex flex-row items-center gap-2">
                    <input className={`input input-bordered flex-1 rounded-md z-1`} value={mapName} placeholder={"Enter map name here ..."} onChange={onMapNameInputChange} />
                </div>
            </div>

            <div className="font-bold text-base pt-8 flex items-center">
                <span>Map URL</span>
            </div>
            <div className="flex w-full gap-2">
                <div className="form-control flex-1 relative flex flex-row items-center gap-2">
                    <span className="shrink-0 text-base-content/70">zipmap.io/</span><input className={`input input-bordered flex-1 rounded-md z-1`} value={mapSlug} placeholder={"Enter map URL here ..."} onChange={onMapSlugInputChange} />
                </div>
            </div>

            <div className="text-left text-md text-base-content/70 pt-8 pb-1">
                Map cover picture
            </div>
            <div className="flex flex-col">
                <input id="upload-cover-photo-input" type="file" accept="image/png, image/jpeg" className="file-input file-input-bordered w-full max-w-xs hidden" onChange={(inputEvent) => { onAddMapFileInputChange(inputEvent, "cover") }}/>
                {
                    !coverPhoto && <div className="w-full text-base-content/50 py-2">
                        🤷🏻‍♀️ No cover photo selected
                    </div>
                }
                {
                    coverPhoto && <LazyLoadImage 
                    className='max-w-[500px] object-containe rounded-md'
                    src={coverPhoto.url}
                    />
                }
                <div className="shrink-0 pt-2"><EditButton onEditClick={() => {
                    document.getElementById('upload-cover-photo-input').click();
                }} /></div>
            </div>

            <div className="text-left text-md text-base-content/70 pt-8 pb-1">
                Map logo
            </div>
            {
                !logoImage && <div className="w-full text-base-content/50 py-2">
                    🤷🏻‍♂️ No logo image selected
                </div>
            }
            <div className="flex flex-col">
                {
                    logoImage && <LazyLoadImage 
                    className='max-w-[200px] object-contain rounded-md'
                    src={logoImage.url}
                    />
                }

                <input id="upload-logo-photo-input" type="file" accept="image/png, image/jpeg" className="file-input file-input-bordered w-full max-w-xs hidden" onChange={(inputEvent) => { onAddMapFileInputChange(inputEvent, "logo") }}/>
                <div className="shrink-0 pt-2"><EditButton onEditClick={() => {
                    document.getElementById('upload-logo-photo-input').click();
                }} /></div>
            </div>

            <div className="text-left text-md text-base-content/70 pt-8 pb-1">
                Map default marker
            </div>
            <div className="flex flex-row items-center">
                <div className="font-bold text-left text-4xl pr-4">
                    {mapDefaultMarker}
                </div>
                <div className="shrink-0 "><EditButton onEditClick={onAddMapDefaultMarkerClick} /></div>
            </div>

            <div className="text-left text-md text-base-content/70 pt-8">
                Map default view
            </div>
            <div className="text-left text-sm text-base-content/50 pb-2">
                Determines when viewers visit your URL, whether they see the map or list view first.
            </div>
            <div className="flex flex-row w-full gap-2">
            <button className={`btn btn-primary mr-2 normal-case ${mapDefaultView === "LIST" ? "" : "btn-outline"}`} onClick={
                    () => {
                        setMapDefaultView("LIST")
                    }
                    } >
                    <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path className={`hover:stroke-primary-content ${mapDefaultView === "LIST" ? "stroke-primary-content" : "stroke-primary"}`} d="M8 6.00067L21 6.00139M8 12.0007L21 12.0015M8 18.0007L21 18.0015M3.5 6H3.51M3.5 12H3.51M3.5 18H3.51M4 6C4 6.27614 3.77614 6.5 3.5 6.5C3.22386 6.5 3 6.27614 3 6C3 5.72386 3.22386 5.5 3.5 5.5C3.77614 5.5 4 5.72386 4 6ZM4 12C4 12.2761 3.77614 12.5 3.5 12.5C3.22386 12.5 3 12.2761 3 12C3 11.7239 3.22386 11.5 3.5 11.5C3.77614 11.5 4 11.7239 4 12ZM4 18C4 18.2761 3.77614 18.5 3.5 18.5C3.22386 18.5 3 18.2761 3 18C3 17.7239 3.22386 17.5 3.5 17.5C3.77614 17.5 4 17.7239 4 18Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>  
                    List
                </button>
                <button className={`btn btn-primary mr-2 normal-case ${mapDefaultView === "MAP" ? "" : "btn-outline"}`} onClick={
                    () => {
                        setMapDefaultView("MAP")
                    }
                    } >
                    <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path className={`hover:stroke-primary-content ${mapDefaultView === "MAP" ? "stroke-primary-content" : "stroke-primary"}`} d="M9 20L3 17V4L9 7M9 20L15 17M9 20V7M15 17L21 20V7L15 4M15 17V4M9 7L15 4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>   
                    Map
                </button>
            </div>

            <div className="font-bold text-base flex items-center pt-8">
                <span>Map description</span>
            </div>
            <div className="flex w-full gap-2 pb-24">
                <div className="form-control flex-1">
                    <Tiptap editor={editor} />
                </div>
            </div>
        </div>
        <div className="modal-action bg-base-100 w-full px-4 py-4 absolute bottom-0 right-0">
            <button className="btn btn-success text-success-content mr-2 normal-case" onClick={
                () => {
                    onAddMapSaveClick()
                }
                } >
                <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path className="stroke-success-content" d="M8 20H6C4.89543 20 4 19.1046 4 18V6C4 4.89543 4.89543 4 6 4H9M8 20V14C8 13.4477 8.44772 13 9 13H15C15.5523 13 16 13.4477 16 14V20M8 20H16M16 20H18C19.1046 20 20 19.1046 20 18V8.82843C20 8.29799 19.7893 7.78929 19.4142 7.41421L16.5858 4.58579C16.2107 4.21071 15.702 4 15.1716 4H15M15 4V7C15 7.55228 14.5523 8 14 8H10C9.44772 8 9 7.55228 9 7V4M15 4H9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>    
                Save
            </button>

            <button className="btn btn-circle btn-soft" onClick={
                    () => {
                        onAddMapModalDismiss()
                    }
                    }>
                <svg className="fill-base-content w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.207 6.207a1 1 0 0 0-1.414-1.414L12 10.586 6.207 4.793a1 1 0 0 0-1.414 1.414L10.586 12l-5.793 5.793a1 1 0 1 0 1.414 1.414L12 13.414l5.793 5.793a1 1 0 0 0 1.414-1.414L13.414 12l5.793-5.793z"/></svg>
            </button>
        </div>
        {
                fullScreenLoadingText &&
                <div className='w-full h-screen absolute max-w-[100%] top-0 flex flex-row items-center justify-center gap-2 backdrop-blur-sm bg-base-100/30 z-50'>
                    <div className="loading loading-infinity loading-lg"></div>
                    <div className='font-normal text-base-content'>{fullScreenLoadingText}</div>
                </div>
        }
        {
                toastMessage && <div className="toast z-10">
                <div className={`alert ${toastMessage.type == "success" ? "alert-success" : "alert-info"}`}>
                <span className="text-sm">{toastMessage.message}</span>
                </div>
            </div>
        }
        {
            <dialog id="pick-add-map-emoji-modal" className="modal">
                <div className="modal-box w-max">
                    <h3 className="font-bold text-lg pb-4">Pick Marker Emoji</h3>
                    <Picker data={data} onEmojiSelect={(emoji) => { onEmojiSelected(emoji.native) }} />
                    <div className="modal-action">
                    <button className="btn btn-circle btn-soft" onClick={
                            () => {
                                document.getElementById("pick-add-map-emoji-modal").close()
                            }
                            }>
                        <svg className="fill-base-content w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.207 6.207a1 1 0 0 0-1.414-1.414L12 10.586 6.207 4.793a1 1 0 0 0-1.414 1.414L10.586 12l-5.793 5.793a1 1 0 1 0 1.414 1.414L12 13.414l5.793 5.793a1 1 0 0 0 1.414-1.414L13.414 12l5.793-5.793z"/></svg>
                    </button>
                    </div>
                </div>
            </dialog>
        }
        </div>
        </Sheet.Scroller>
        </Sheet.Content>
        </Sheet.Container>
        <Sheet.Backdrop onTap={(_) => {
            onAddMapModalDismiss()
        }}/>
    </Sheet>
</>
}